import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cc542af&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc542af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc542af')) {
      api.createRecord('0cc542af', component.options)
    } else {
      api.reload('0cc542af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0cc542af&scoped=true", function () {
      api.rerender('0cc542af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/CollectionForwardingCentreHomeDeliveryCmp/index.vue"
export default component.exports